<template>
  <p class="inline-notice" :class="variantClass">
    <span v-if="icon" class="inline-notice-icon" aria-hidden="true">{{
      icon
    }}</span>
    <span class="inline-notice-text">
      <slot>{{ text }}</slot>
    </span>
  </p>
</template>

<script>
export default {
  name: 'InlineNotice',
  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'muted',
      validator: (value) => ['muted', 'privacy', 'legal'].includes(value),
    },
  },
  computed: {
    variantClass() {
      return `inline-notice--${this.variant}`
    },
  },
}
</script>

<style scoped>
.inline-notice {
  margin: 14px auto 0;
  max-width: 320px;
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
}

.inline-notice-icon {
  font-size: 12px;
  line-height: 1.4;
  color: #6f7868;
  flex-shrink: 0;
  transform: translateY(1px);
}

.inline-notice-text {
  display: inline;
}

.inline-notice--muted {
  color: #616a5c;
}

.inline-notice--privacy {
  color: #616a5c;
}

.inline-notice--legal {
  color: #71796a;
}

.inline-notice :deep(a) {
  color: #445526;
  font-weight: 700;
  text-decoration: none;
}
</style>
